module.exports = __webpack_public_path__ + "24e004ab/img/arrow-export-icon.a3345173.svg";